
import * as React from 'react'; 
import PropTypes from 'prop-types';
import { Box, IconButton, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import './utils/css/ConfigMenu.css'; // Archivo de estilos
import TranslateIcon from '@mui/icons-material/Translate';
import Logo from '../assets/img/ITG_BLANCO.png';
import Traductor from '../components/Traductor';
// Íconos
import SettingsIcon from '@mui/icons-material/Settings';
import EngineeringIcon from '@mui/icons-material/Engineering';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import PaidRoundedIcon from '@mui/icons-material/PaidRounded';
import { GiSchoolOfFish } from 'react-icons/gi';
import CentrosYCiclos from './CentrosYCiclos'
import LogsUsuarios from './LogsUsuarios';
import CrearUsuarios from '../components/CrudUsuarios/CrearUsuarios';
import AiUsageDashboard from '../features/ai-usage/AiUsageDashboard';
import { normalizeSuperuserCargo } from '../features/ai-usage/aiUsageClient';

import { useParams } from 'react-router-dom';


export default function ConfigMenu({       translate,
    handleClick,
    openMenuIdioma,
    handleCloseIdioma,
    handleLanguageChange,
    cargo,
    idioma  }) {
  const t = (key, fallback) => {
    const value = typeof translate === 'function' ? translate(key) : key;
    return value && value !== key ? value : fallback;
  };
  const navigate = useNavigate();
  const superUser = normalizeSuperuserCargo(cargo);

  const { tab, token } = useParams()
  // Definición de pestañas (el índice 0 es un placeholder)
  const tabsData = [
    { label: t('centros_title', 'Centros y ciclos'), route:`create_center`,  icon: <GiSchoolOfFish className='icon-m' />, rotation: rotaciones },
    // { label: 'Crud Usuarios', route:'analytic',  icon: <QueryStatsIcon className='icon-m' />, rotation: rotaciones },
    { label: 'Usuarios', route:`create_users`,  icon: <GroupAddIcon className='icon-m' />, rotation: rotaciones },
    // { label: 'Editar Usuarios', route:'edit_users',  icon: <FaUserEdit className='icon-m' />, rotation: rotaciones },
    ...(superUser ? [
      { label: `Logs Usuarios`, route:'logs', icon:  <EngineeringIcon className='icon-m' />, rotation: rotaciones },
      { label: `Uso IA`, route:'ai_usage', icon:  <PaidRoundedIcon className='icon-m' />, rotation: rotaciones },
    ] : []),
  ];
  
  const [menuTabIndex, setMenuTabIndex] = React.useState(0); // Se inicia en la pestaña 1
  const [rotationTrigger, setRotationTrigger] = React.useState(0);
  const [prevTabIndex, setPrevTabIndex] = React.useState(1);
  const [rotationAnimation, setRotationAnimation] = React.useState('rotationBack'); // Animación por defecto

  // Actualiza la pestaña seleccionada al hacer click en un botón
  // const handleChangeTab = (newValue) => {
  //   setMenuTabIndex(newValue);
  //   setRotationTrigger((prev) => prev + 1);
  //   navigate(`/config/${newValue}`);
  // };
  const handleChangeTab = (newValue) => {
    // Comparamos para ver si el nuevo índice es menor que el actual
    if (newValue < menuTabIndex) {
      setRotationAnimation('rotationBackInverse');
    } else {
      setRotationAnimation('rotationBack');
    }
    setPrevTabIndex(menuTabIndex);
    //setMenuTabIndex(newValue);
    setRotationTrigger(prev => prev + 1);
    //navigate(`/config/${newValue}`);
    navigate(`/config/${tabsData[newValue].route}`)
  };

  /* Cambiar tab desde URL */
  React.useEffect(() => {
    // Buscar en tabsData la pestaña cuyo 'route' coincida con el parámetro 'tab'
    const tabIndex = tabsData.findIndex((item) => item.route === tab);
  
    // Si se encuentra, se actualiza el estado; si no, se puede asignar un valor por defecto (por ejemplo, 0)
    setMenuTabIndex(tabIndex !== -1 ? tabIndex : 0);
  }, [tab]);

  const Exit = () => {
    window.location.href = '/home';
  };


  // Altura para posicionar el indicador de la tarjeta
  // const tabHeightVh = 5.98;
  // console.log('token',token)
  const Props ={
        translate,
        handleClick,
        openMenuIdioma,
        handleCloseIdioma,
        handleLanguageChange,
        cargo,
        idioma
  }
  return (
    <>
      <div className='appbar-config'> 
        <div className="config-brand-block" onClick={Exit}>
          <img
            src={Logo}
            style={{
              width: '4vw',
              objectFit:'contain',
              // aspectRatio: '1.6',
              cursor: 'pointer',
            }}
          />
        </div>
        <div className="config-top-actions">
          <IconButton onClick={handleClick} className="config-translate-trigger">
            <TranslateIcon style={{fontSize:'2vh', color:'#e84e0e'}}/>
          </IconButton>
          <Traductor handleLanguageChange ={handleLanguageChange} openMenuIdioma ={openMenuIdioma} handleCloseIdioma ={handleCloseIdioma} idioma={idioma} translate={translate} />
        </div>
      </div>
      {/* Iconos rotatorios */}
      <div className="container-icon-setting">
        <SettingsIcon
          key={`large-${rotationTrigger}`}
          className='icon-setting large'
          style={{
            // animation: `rotationBack 3s linear ${rotaciones}`,
            animation: `${!rotationAnimation === 'rotationBack' ? 'rotationBackInverse' : 'rotationBack'} 3s linear ${rotaciones}`,
            animationFillMode: 'forwards',
          }}
        />
        <SettingsIcon
          key={`medium-${rotationTrigger}`}
          className='icon-setting medium'
          style={{
            // animation: `rotationBackInverse 3s linear ${rotaciones}`,
            animation: `${rotationAnimation === 'rotationBack' ? 'rotationBackInverse' : 'rotationBack'} 3s linear ${rotaciones}`,
            animationFillMode: 'forwards',
          }}
        />
      </div>
        
      <Box className={`vertical-tabs-container ${menuTabIndex === 0 ? "centros-config" : ""}`}>

        {/* Botones que reemplazan a los Tabs */}
        <Box className="tabs-wrapper">
          {tabsData
            // .filter((_, index) => index !== 0)  // Excluimos el placeholder (índice 0)
            .map((tab, index) => {
              // Ajustamos el índice real (ya que filtramos el índice 0)
              const actualIndex = index ;
              const isSelected = menuTabIndex === actualIndex;
              const hasSubmenus = !!tab.submenus;
              return (
                
                  <StyledBox
                    key={actualIndex}
                    onClick={() => handleChangeTab(actualIndex)}
                    {...a11yProps(actualIndex)}
                    selected={isSelected} /*  ? 1 : 0} */
                    hasSubmenus={hasSubmenus} /*  ? 1 : 0} */
                    className={actualIndex === menuTabIndex ? 'hidden-tab' : ''}
                    isSelected={isSelected}
                    index={index}
                  >
                    <div className="tooltip-StyledBox">
                      {/* Tooltip sensor */}
                    <span className={`tooltip-config ${index === 6 && 'secret'}`}> {tab.label}</span>
                    {!isSelected &&tab.icon}
                    </div>
                    {isSelected && (
                      <>
                        <div className="tab-1">
                          {tab.icon}
                          <h1 className="h1-tab">{tab.label}</h1>
                        </div>
                        
                        {/* SubMenus */}
                     
                    
                      </>
                  )}
                  </StyledBox>
              );
            })
          }
        </Box>
     
        {/* Panel principal */}
        <div className="container-tab-panel">
          
          <TabPanel menuTabIndex={menuTabIndex} index={0}>
            <CentrosYCiclos {...Props} />
          </TabPanel>
          {/* <TabPanel menuTabIndex={menuTabIndex} index={1}>
            <Registro {...Props} />
          </TabPanel> */}
          <TabPanel menuTabIndex={menuTabIndex} index={1}>
              <CrearUsuarios {...Props}/>
          </TabPanel>
           {/*<TabPanel menuTabIndex={menuTabIndex} index={2}>
            <EditarUsuarios {...Props}/>
          </TabPanel>*/}
          <TabPanel menuTabIndex={menuTabIndex} index={2}>
            <LogsUsuarios {...Props}/>
          </TabPanel>
          <TabPanel menuTabIndex={menuTabIndex} index={3}>
            <AiUsageDashboard {...Props}/>
          </TabPanel>
        </div>
      </Box>
    </>
  );
}



function TabPanel(props) {
  const { children, menuTabIndex, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={menuTabIndex !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {menuTabIndex === index && (
        <Box className="config-tab-panel-body">
          {/* <Typography> */}
            {children}
            {/* </Typography> */}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  menuTabIndex: PropTypes.number.isRequired,
};

// Función para accesibilidad
function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const rotaciones = 0.15; // Número de rotaciones

// Botón estilizado que emula el Tab
const StyledBox = styled(Box)(({ theme, selected, hasSubmenus,isSelected, index }) => ({
  minHeight: index=== 6 ? '9vh': selected && hasSubmenus ? '15.5vh' : '4.5vh',
  maxHeight: index=== 6 ? '9vh': selected && hasSubmenus ? '15.5vh' : '4.5vh',
  minWidth: isSelected? '13.8vw' : '3.1vw',
  maxWidth: isSelected? '13.8vw' : '3.1vw',
  marginLeft: !isSelected ?'6.2vw':'13.55vw',
  padding: isSelected ? '0 0.8vw' : 0,
  marginTop: index===0?'5.5vh' : '1.4vh',
  borderTop: !isSelected && 'solid 0.01vh rgba(195,195,195,0.4)',
  borderBottom: !isSelected && 'solid 0.01vh rgba(195,195,195,0.4)',
  borderLeft: !isSelected && 'solid 0.01vh rgba(195,195,195,0.4)',
  borderTopLeftRadius: !isSelected && '0.9vw',
  borderBottomLeftRadius: !isSelected && '0.9vw',
  border: isSelected && 'solid 0.01vh rgba(233, 78, 26, 0.95)',
  borderRadius: isSelected &&'1vw',
  background: isSelected
    ? 'linear-gradient(180deg, rgba(17, 28, 43, 0.98), rgba(10, 17, 29, 0.98))'
    : 'linear-gradient(180deg, rgba(17, 24, 36, 0.88), rgba(10, 14, 23, 0.9))',
  boxShadow: isSelected
    ? '0 0.6vw 1.4vw rgba(0,0,0,0.2), inset 0 0 0 0.01vw rgba(255,255,255,0.03)'
    : '0 0.35vw 0.8vw rgba(0,0,0,0.12)',
  transition: 'all 0.3s ease',
  display: 'flex',
  justifyContent:!isSelected ? 'center' :'space-between',
  alignContent:!isSelected ? 'center' :'space-between',
  alignItems:!isSelected ? 'center' :'space-between',
  textAlign:!isSelected ? 'center' :'space-between',
  flexDirection: 'column',
  textTransform: 'none',
  ":hover":{
    border: !isSelected && 'solid 0.01vh rgba(233, 78, 26, 0.9)',
    transform: !isSelected && 'translateX(-0.15vw)',
  }
}));
